import { IconType } from '@/types';

export default function PriceBookIcon({
  color = '#4DACE0',
  width = 24,
  height = 28,
  className,
}: IconType) {
  return (
    <svg
      width={width}
      height={height}
      className={className}
      viewBox='0 0 512 512' // Diperbesar untuk menampung semua path
      fill='none'
      version='1.1'
      id='Layer_1'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g>
        <g>
          <g>
            <path
              d='M509.013,307.621L204.379,2.987C202.467,1.075,199.872,0,197.167,0h-80.851c-2.705,0-5.299,1.075-7.212,2.987
				L2.988,109.104C1.075,111.016,0,113.611,0,116.316v80.851c0,2.705,1.075,5.299,2.987,7.212l304.635,304.634
				c1.913,1.912,4.507,2.987,7.212,2.987s5.299-1.075,7.212-2.987l186.967-186.967C512.996,318.062,512.996,311.604,509.013,307.621
				z M314.834,487.377L20.399,192.942V120.54L120.54,20.398h72.402l294.435,294.435L314.834,487.377z'
              fill={color} // Menggunakan color prop
            />
            <path
              d='M109.459,74.757c-9.27,0-17.983,3.609-24.537,10.164s-10.165,15.268-10.165,24.537s3.609,17.983,10.164,24.537
				c6.765,6.765,15.652,10.147,24.537,10.147c8.887,0,17.772-3.382,24.538-10.147c13.53-13.53,13.53-35.544,0-49.074
				C127.442,78.367,118.728,74.757,109.459,74.757z M119.572,119.571c-5.578,5.577-14.651,5.576-20.227,0
				c-2.702-2.702-4.19-6.293-4.19-10.114c0-3.821,1.488-7.412,4.19-10.114c2.702-2.701,6.293-4.189,10.114-4.189
				c3.821,0,7.412,1.488,10.114,4.19C125.147,104.921,125.147,113.995,119.572,119.571z'
              fill={color} // Menggunakan color prop
            />
          </g>
        </g>
      </g>
      <g>
        <g>
          <path
            d='M351.835,336.621c18.64-24.212,20.354-52.493-5.571-78.419c-29.353-29.353-56.993-19.711-81.204-8.356l-53.136-53.136
			c16.927-15.212,30.425-14.57,34.282-18.426c3.856-3.856,1.071-11.356-1.714-14.141c-7.071-7.07-29.568,4.714-45.637,19.497
			l-6.213-6.213c-2.142-2.142-6.642-1.499-8.999,0.858c-2.785,2.785-3,6.856-0.857,8.999l6.643,6.643
			c-17.356,19.925-29.14,48.85-2.143,75.847c27.426,27.425,53.992,13.712,79.489,1.499l62.349,62.349
			c-27.209,25.925-48.85,13.712-53.993,18.854c-3.213,3.214-1.928,10.926,1.5,14.355c7.713,7.714,38.78,7.07,65.991-19.712
			l7.712,7.713c2.142,2.143,6.214,1.929,8.999-0.857c2.357-2.357,3.001-6.856,0.858-8.999L351.835,336.621z M199.499,254.988
			c-15.855-15.855-9.213-34.067,3.214-48.637l49.708,49.708C233.565,265.058,216.21,271.7,199.499,254.988z M337.909,323.979
			l-58.493-58.492c18.212-7.499,35.782-10.926,54.423,7.714C349.693,289.055,350.551,306.624,337.909,323.979z'
            fill={color} // Menggunakan color prop
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d='M278.512,122.827l-59.155-59.155c-3.984-3.983-10.442-3.984-14.425,0c-3.983,3.984-3.983,10.442,0,14.425l59.155,59.155
			c1.992,1.992,4.601,2.987,7.212,2.987c2.611,0,5.22-0.995,7.213-2.987C282.495,133.268,282.495,126.81,278.512,122.827z'
            fill={color} // Menggunakan color prop
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d='M194.878,39.195l-2.55-2.55c-3.984-3.983-10.442-3.983-14.425,0c-3.983,3.984-3.983,10.442,0,14.425l2.55,2.55
			c1.991,1.992,4.602,2.987,7.212,2.987c2.611,0,5.221-0.995,7.213-2.987C198.861,49.635,198.861,43.177,194.878,39.195z'
            fill={color} // Menggunakan color prop
          />
        </g>
      </g>
    </svg>
  );
}
